(ns common.ocp.db
  (:require [common.spec]
            [re-frame.core :as rf]))

(rf/reg-event-db :ocp/register
  (fn [db [_ id options content]]
    (assoc-in db [:ocp :registry id] (assoc options :content content :id id))))

(rf/reg-event-fx :ocp/open
  (fn [{:keys [db]} [_ {:keys [id on-close props]}]]
    {:db (update db :ocp assoc
                 :open true
                 :id id
                 :on-close on-close
                 :props props)}))

(rf/reg-event-fx :ocp/close
  (fn [{:keys [db]} _]
    {:db (update db :ocp dissoc :open)}))

(rf/reg-event-fx :ocp/closed
  (fn [{:keys [db]} _]
    (let [on-close (-> db :ocp :on-close)]
      {:db (update db :ocp select-keys [:registry])
       :fx [(when on-close
              [:dispatch on-close])]})))

(rf/reg-event-db :ocp/update-props
  (fn [db [_ props]]
    (update-in db [:ocp :props] merge props)))

(rf/reg-sub :ocp
  (fn [db _]
    (:ocp db)))

(rf/reg-sub :ocp/props
  :<- [:ocp]
  (fn [ocp _]
    (:props ocp)))

(rf/reg-sub :ocp/open?
  :<- [:ocp]
  (fn [ocp _]
    (boolean (:open ocp))))

(rf/reg-sub :ocp/current
  :<- [:ocp]
  (fn [{:keys [registry id]} _]
    (get registry id)))

